"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = BookButton;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _react2 = require("@xstate/react");
var _xstate = require("xstate");
var _propTypes = require("prop-types");
var _intl = require("@kyruus/intl");
var _button = require("@kyruus/button");
var _Actions = require("../../lib/constants/Actions");
var _States = require("../../lib/constants/States");
var _messages = _interopRequireDefault(require("../../lib/messages"));
var _Tracking = require("../../lib/constants/Tracking");
var _styles = require("./styles");
var _Banners = require("../Banners");
const propTypes = {
  service: (0, _propTypes.instanceOf)(_xstate.Interpreter).isRequired,
  track: _propTypes.func.isRequired
};
function BookButton(_ref) {
  let {
    service,
    track,
    ...props
  } = _ref;
  const [state, send] = (0, _react2.useService)(service);
  if (state.matches(_States.apptUnavailable)) {
    return /*#__PURE__*/_react.default.createElement(_styles.BannerWrapper, null, /*#__PURE__*/_react.default.createElement(_Banners.AppointmentUnavailableBanner, null));
  }
  return /*#__PURE__*/_react.default.createElement(_button.ButtonWithSpinner, (0, _extends2.default)({}, props, {
    showSpinner: state.matches(_States.bookingAppt),
    disabled: state.matches(_States.bookingAppt) || state.matches(_States.success),
    onClick: () => {
      track(_Tracking.userEvents.BOOK_APPT);
      send(_Actions.BOOK_APPT);
    }
  }), /*#__PURE__*/_react.default.createElement(_intl.FormattedMessage, _messages.default.bookAppointment));
}
BookButton.propTypes = propTypes;
BookButton.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "BookButton",
  "props": {
    "service": {
      "description": "",
      "type": {
        "name": "instanceOf",
        "value": "Interpreter"
      },
      "required": true
    },
    "track": {
      "description": "",
      "type": {
        "name": "func"
      },
      "required": true
    }
  }
};